import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  padding: 80px 0;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`;

const Title = styled.div`
  font-size: 42px;
  font-weight: 600;
  color: #343a40;
`;

const SubTitle = styled.div`
  font-size: 18px;
  color: #6c757d;
  line-height: 1.6;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const Card = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 30px;
  border: 1px solid #dee2e6;
`;

const CardIcon = styled.div`
  font-size: 36px;
  margin-bottom: 20px;
  color: #007bff;
`;

const CardTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 15px;
`;

const CardDescription = styled.div`
  font-size: 16px;
  color: #6c757d;
  line-height: 1.7;
`;

const AboutSection = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <Header>
            <Title>About Following Moments</Title>
            <SubTitle>
              우리는 기술을 통해 사람들의 순간을 더욱 의미있게 만들고,
              <br />
              장소와 경험을 연결하여 새로운 가치를 창출합니다.
            </SubTitle>
          </Header>

          <CardsContainer>
            <Card>
              <CardIcon>🎯</CardIcon>
              <CardTitle>우리의 미션</CardTitle>
              <CardDescription>
                장소를 중심으로 사람들을 연결하고, 모든 순간을 기록하며 공유할 수 있는
                플랫폼을 제공하여 더 풍요로운 경험을 만들어갑니다.
              </CardDescription>
            </Card>

            <Card>
              <CardIcon>🚀</CardIcon>
              <CardTitle>우리의 비전</CardTitle>
              <CardDescription>
                위치 기반 소셜 네트워크의 선두주자로서, 전 세계 사람들이
                자신의 경험을 공유하고 새로운 장소를 발견하는 혁신적인 플랫폼을 구축합니다.
              </CardDescription>
            </Card>

            <Card>
              <CardIcon>💡</CardIcon>
              <CardTitle>우리의 접근</CardTitle>
              <CardDescription>
                사용자 중심의 디자인과 최신 기술을 결합하여 직관적이고
                매력적인 서비스를 제공하며, 지속적인 혁신을 추구합니다.
              </CardDescription>
            </Card>
          </CardsContainer>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default AboutSection;
